import styled from 'styled-components';

const getSize = p => (p.device === 'mobile' ? 1.25 : 1.5);

export const StepNumber = styled.div`
  background: #333;
  border-radius: 50%;
  box-shadow: 0 0 0 2px #fff;
  color: #fff;
  height: ${getSize}rem;
  line-height: ${getSize}rem;
  position: absolute;
  right: 1rem;
  text-align: center;
  top: 1rem;
  width: ${getSize}rem;
  ${p => p.device === 'mobile' && 'font-size: 12px;'}
`;
